/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementShowGroupResponse } from "./GroupManagementShowGroupResponse";

export type GroupManagementShowGroupResponseApiRespoonse = {
  data?: GroupManagementShowGroupResponse;
  status?: GroupManagementShowGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementShowGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
